import React from "react";
import { ListingBadge } from "@domain-group/fe-allhomes-library";
import * as styles from "./allhomes-listing-badges.style";
import { ListingBadge as ListingBadgeComponent } from "./listing-badge";
import { jsx as ___EmotionJSX } from "@emotion/core";
var getBadges = function getBadges() {
  var annotations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var badges = annotations.map(_ref => {
    var badge = _ref.badge;
    return badge;
  });
  return annotations.map(annotation => ({
    badge: ListingBadge[annotation.badge],
    annotation
  })).filter(_ref2 => {
    var badge = _ref2.badge;
    return badge ? !((badge === null || badge === void 0 ? void 0 : badge.showUnless) || []).some(vetoBadge => badges.includes(vetoBadge)) : false;
  }).sort((badgeA, badgeB) => (badgeA.badge.priority || 0) - (badgeB.badge.priority || 0));
};
var getLabel = (annotation, labelType) => {
  switch (labelType) {
    case "full":
      return annotation.label;
    case "short":
      return annotation.shortLabel;
    default:
      return annotation.tinyLabel;
  }
};
export var AllhomesListingBadges = _ref3 => {
  var _ref3$annotations = _ref3.annotations,
    annotations = _ref3$annotations === void 0 ? [] : _ref3$annotations,
    _ref3$labelType = _ref3.labelType,
    labelType = _ref3$labelType === void 0 ? "tiny" : _ref3$labelType,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? "medium" : _ref3$size;
  return ___EmotionJSX("div", {
    css: styles.wrapper(size),
    "data-testid": "badges"
  }, getBadges(annotations).map(_ref4 => {
    var badge = _ref4.badge,
      annotation = _ref4.annotation;
    return ___EmotionJSX(ListingBadgeComponent, {
      badge: badge,
      label: getLabel(annotation, labelType),
      size: size,
      key: annotation.badge
    });
  }));
};